import { json } from "@codemirror/lang-json";
import { tags as t } from "@lezer/highlight";
import { createTheme } from "@uiw/codemirror-themes";
import CodeMirror from "@uiw/react-codemirror";

const theme = createTheme({
  theme: "light",
  settings: {
    background: "#ffffff",
    foreground: "#1f2328",
    caret: "#ff6b6b",
    selection: "#bcd4f8",
    selectionMatch: "#555555",
    gutterBackground: "#ffffff",
    gutterForeground: "#c5c7d0"
  },
  styles: [
    { tag: t.propertyName, color: "#F98500", fontWeight: 500 },

    { tag: t.string, color: "#088C7A" },

    { tag: t.number, color: "#F98500" },

    // Boolean & null → abu gelap
    { tag: t.bool, color: "#5c6166", fontStyle: "italic" },
    { tag: t.null, color: "#5c6166", fontStyle: "italic" },

    // Brackets + braces
    { tag: t.brace, color: "#6e7781" },
    { tag: t.squareBracket, color: "#6e7781" },
    { tag: t.bracket, color: "#6e7781" },

    { tag: t.comment, color: "#821", fontStyle: "italic" }
  ]
});

const extensions = [json()];

interface GeoJsonInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const GeoJsonInput = ({ value, onChange }: GeoJsonInputProps) => {
  return (
    <div className="rounded-xl border overflow-hidden">
      <CodeMirror
        aria-label="geojson-input"
        value={value}
        height="200px"
        theme={theme}
        extensions={extensions}
        onChange={onChange}
      />
    </div>
  );
};
